import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-6 grid-rows-2 gap-x-4 gap-y-4" }
const _hoisted_2 = { class: "col-span-6" }
const _hoisted_3 = {
  value: null,
  disabled: "",
  selected: ""
}
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "col-span-3" }
const _hoisted_6 = { class: "col-span-3" }
const _hoisted_7 = { class: "col-span-6" }

import {
  reactive,
  ref,
  onMounted,
  watchEffect,
  computed,
} from "vue";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import Modal from "@/components/common/Modal.vue";
import { useStore } from "vuex";
import { TransferAuthorityTypes } from "@/store/modules/transferAuthority/state";
import { TransferAuthorityActions } from "@/store/modules/transferAuthority/actions";
import { UserGetters } from "@/store/modules/user/getters";
import { UserActions } from "@/store/modules/user/actions";
import Button from "@/components/common/Button.vue";
import { useToast } from "vue-toastification";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
  show: {
    type: Boolean,
    default: false,
  },
},
  emits: ["hide"],
  setup(__props, { emit }) {

const props = __props

const toast = useToast();



const state = reactive({
  ioUserId: null,
  reason: "",
  startedAt: null,
  expiredAt: null,
});
const rules = {
  ioUserId: { required },
  reason: { required },
  startedAt: { required },
  expiredAt: { required },
};

const store = useStore();

const submitted = ref(false);
const v$ = useVuelidate(rules, state);

async function handleSubmit(isFormValid: boolean) {
  submitted.value = true;
  if (!isFormValid) {
    return;
  }

  if (state!.startedAt >= state!.expiredAt) {
    toast.warning(t("transferAuthority.invalidDate"));
    return;
  }

  try {
    await store.dispatch(TransferAuthorityActions.CREATE, {
      ioUserId: state.ioUserId,
      reason: state.reason,
      startedAt: state.startedAt,
      expiredAt: state.expiredAt,
    });
    toast.success(t("transferAuthority.createSuccess"));
    state.ioUserId = null;
    state.reason = "";
    state.startedAt = null;
    state.expiredAt = null;
    submitted.value = false;
    v$.value.$reset();
    emit("hide");
  } catch (error: any) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.data ||
      t("transferAuthority.createError");
    toast.error(typeof message === "string" ? message : t("transferAuthority.createError"));
  }
}

const usersDataProvider = computed(
  () => store.getters[UserGetters.GET_DATA_PROVIDER]
);

onMounted(async () => {
  await store.dispatch(UserActions.FETCH_DATA_PROVIDER);
});

return (_ctx: any,_cache: any) => {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createBlock(Modal, {
    onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('hide'))),
    show: __props.show,
    title: _unref(t)('transferAuthority.createModalTitle')
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", {
              class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).ioUserId.$invalid && submitted.value }]),
              for: "user-id"
            }, _toDisplayString(_unref(t)("logs.user")), 3),
            _withDirectives(_createElementVNode("select", {
              id: "user-id",
              class: _normalizeClass(["input-form w-full", {
              'p-invalid': _unref(v$).ioUserId.$invalid && submitted.value,
            }]),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).ioUserId.$model) = $event))
            }, [
              _createElementVNode("option", _hoisted_3, _toDisplayString(_unref(t)("transferAuthority.selectUser")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(usersDataProvider).items, (user) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: user.id,
                  key: user.id
                }, _toDisplayString(user.surname) + " " + _toDisplayString(user.name), 9, _hoisted_4))
              }), 128))
            ], 2), [
              [_vModelSelect, _unref(v$).ioUserId.$model]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", {
              class: _normalizeClass(["input-form-label", {
              'p-error': _unref(v$).startedAt.$invalid && submitted.value,
            }])
            }, _toDisplayString(_unref(t)("transferAuthority.startDateLabel")), 3),
            _createVNode(_component_Datepicker, {
              locale: "ru",
              selectText: _unref(t)('logs.apply'),
              cancelText: _unref(t)('logs.cancel'),
              placeholder: _unref(t)('logs.datePlaceholder'),
              enableTimePicker: false,
              modelValue: _unref(v$).startedAt.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).startedAt.$model) = $event)),
              format: "dd/MM/yyyy",
              previewFormat: "dd/MM/yyyy"
            }, null, 8, ["selectText", "cancelText", "placeholder", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", {
              class: _normalizeClass(["input-form-label", {
              'p-error': _unref(v$).expiredAt.$invalid && submitted.value,
            }])
            }, _toDisplayString(_unref(t)("transferAuthority.endDateLabel")), 3),
            _createVNode(_component_Datepicker, {
              locale: "ru",
              selectText: _unref(t)('logs.apply'),
              cancelText: _unref(t)('logs.cancel'),
              placeholder: _unref(t)('logs.datePlaceholder'),
              enableTimePicker: false,
              modelValue: _unref(v$).expiredAt.$model,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).expiredAt.$model) = $event)),
              format: "dd/MM/yyyy",
              previewFormat: "dd/MM/yyyy"
            }, null, 8, ["selectText", "cancelText", "placeholder", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", {
              class: _normalizeClass(["input-form-label", {
              'p-error': _unref(v$).reason.$invalid && submitted.value,
            }])
            }, _toDisplayString(_unref(t)("transferAuthority.reason")), 3),
            _withDirectives(_createElementVNode("textarea", {
              class: _normalizeClass(["input-form w-full", {
              'p-invalid': _unref(v$).reason.$invalid && submitted.value,
            }]),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).reason.$model) = $event))
            }, null, 2), [
              [_vModelText, _unref(v$).reason.$model]
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(Button, { type: "submit" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("common.create")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["show", "title"]))
}
}

})